/** Questionnaire field types for Anmälningar frågeformulär. */
export const QUESTIONNAIRE_FIELD_TYPES = {
  HEADING: 'heading',
  CONSENT: 'consent',
  MULTI_SELECT: 'multi_select',
  SINGLE_SELECT: 'single_select',
  TEXT: 'text',
  DATE: 'date',
  PHOTO: 'photo',
};

export const QUESTIONNAIRE_FIELD_TYPE_LABEL_KEYS = {
  [QUESTIONNAIRE_FIELD_TYPES.HEADING]: 'anmalningar_q_type_heading',
  [QUESTIONNAIRE_FIELD_TYPES.CONSENT]: 'anmalningar_q_type_consent',
  [QUESTIONNAIRE_FIELD_TYPES.MULTI_SELECT]: 'anmalningar_q_type_multi_select',
  [QUESTIONNAIRE_FIELD_TYPES.SINGLE_SELECT]: 'anmalningar_q_type_single_select',
  [QUESTIONNAIRE_FIELD_TYPES.TEXT]: 'anmalningar_q_type_text',
  [QUESTIONNAIRE_FIELD_TYPES.DATE]: 'anmalningar_q_type_date',
  [QUESTIONNAIRE_FIELD_TYPES.PHOTO]: 'anmalningar_q_type_photo',
};

export const QUESTIONNAIRE_FIELD_TYPE_ORDER = [
  QUESTIONNAIRE_FIELD_TYPES.HEADING,
  QUESTIONNAIRE_FIELD_TYPES.MULTI_SELECT,
  QUESTIONNAIRE_FIELD_TYPES.SINGLE_SELECT,
  QUESTIONNAIRE_FIELD_TYPES.TEXT,
  QUESTIONNAIRE_FIELD_TYPES.DATE,
  QUESTIONNAIRE_FIELD_TYPES.PHOTO,
];

/** Mirrors backend DEFAULT_ANMALNING_QUESTIONNAIRE_FIELDS for first-time UI hint. */
export const DEFAULT_QUESTIONNAIRE_FIELD_COUNT = 14;
